import { ColumnHelper, HeaderContext } from "@tanstack/react-table";
import { Button } from "PFComponents/button";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { CustomValueImport } from "PFTypes";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { ImportModalPage } from "../../../../../constants/import_modal_page";
import { useImportSkillsModalContext } from "../../../../../contexts/import_skills_modal_context";

export const useColumnsGenerator = () => {
  const { t } = useTranslation("skillsManagement", {
    keyPrefix: "header.modals.import.history.table.headers"
  });
  const { formatDate } = useDateFormatter();
  const { setImportData, setCurrentPage } = useImportSkillsModalContext();

  const header = useCallback(
    (header: HeaderContext<CustomValueImport, unknown>) => (
      <Typography variant="h5">{t(header.header.id as unknown as TemplateStringsArray)}</Typography>
    ),
    [t]
  );

  return useCallback(
    (columnHelper: ColumnHelper<CustomValueImport>) => [
      columnHelper.accessor((row) => row.createdAt, {
        id: "createdAt",
        header,
        cell: (info) =>
          info.getValue() && (
            <Button
              kind="text"
              onClick={() => {
                setImportData(info.row.original);
                setCurrentPage(ImportModalPage.ImportDataTable);
              }}
            >
              {formatDate(info.getValue())}
            </Button>
          ),
        enableSorting: true,
        size: 200
      }),
      columnHelper.accessor((row) => row.csvAttachment.filename, {
        id: "fileName",
        header,
        cell: (info) => info.getValue(),
        enableSorting: false
      }),
      columnHelper.accessor((row) => row.creator, {
        id: "createdBy",
        header,
        cell: (info) => info.getValue() && getProfileName(info.getValue()),
        enableSorting: false
      })
    ],
    [formatDate, header, setCurrentPage, setImportData]
  );
};
